import {useState,useEffect} from "react";
import { Link ,useLocation, useOutletContext, useNavigate } from "react-router-dom";
import CtntTop5InqApi from "Apis/CtntTop5InqApi";
import GameSvcCtntPstdLstInqApi from "Apis/GameSvcCtntLstInqApi";
import MgpStore from "Stores/Store";
import Pagination from "react-js-pagination";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import "Assets/css/Ctnt.css";
import { Helmet } from "react-helmet-async";
import ApiError from "Utils/ApiError";
import GameSvcCtntLstTopFixInqApi from "Apis/GameSvcCtntLstTopFixInqApi";
import CtntCategoryMenu from "Components/CtntCategoryMenu";
import GamePageBanner from "Components/GamePageBanner";
const GameCtntPstdLstUi = ({gameSvcCd,ctntKindCd,ctntCtgrCdName,LstType}:any) => {
    const {gameMainPageData, langData}:any = useOutletContext();
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobileCategoryOpen, setIsMobileCategoryOpen] = useState(false);
    
    // const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const [pageState, setPageState] = useState(1);
    const [onePageSizeState,setOnePageSizeState] = useState();
    const [totPstdCntState,setTotPstdCntState] = useState(1);
    const [ctntTypeState,setctntTypeState] = useState<string|null>();
    
    // URL 파라미터 실시간 추출 (메뉴 변경 및 페이지 변경 감지용)
    const getCurrentParams = () => {
        const currentParams = new URLSearchParams(location.search);
        return {
            currentGameSvcCd: currentParams.get("gameSvcCd") || gameSvcCd,
            currentCtntCtgrCd: currentParams.get("ctntKindCd") || ctntKindCd,
            currentPage: parseInt(currentParams.get("page") || "1")
        };
    };
    
    const handlePageChange = (newPage:any) => {
        const { currentGameSvcCd, currentCtntCtgrCd } = getCurrentParams();
        
        // URL 파라미터 업데이트
        const newParams = new URLSearchParams(location.search);
        newParams.set("page", newPage.toString());
        navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    };
    
    // 기존 파라미터 로직 (초기값 설정용)
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query = serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let getctntKindCd = query.get("ctntKindCd");
    
    if(getGameSvcCd != null){
        gameSvcCd = getGameSvcCd;
        ctntKindCd = getctntKindCd;
    }

    if(gameSvcCd == null) {
        gameSvcCd = location.state?.gameSvcCd;
    }
    if(ctntKindCd == null) {
        ctntKindCd = location.state?.ctntKindCd;
    }
    
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
    const [ctntKindCdState,setCtntKindCdState] = useState<any>();
    const [topFixCtntState,setTopFixCtntState] = useState<any>();
    
    useEffect(()=>{
        const { currentGameSvcCd, currentCtntCtgrCd, currentPage } = getCurrentParams();
        
        // 페이지 상태 동기화
        setPageState(currentPage);
        
        // 일반 게시글 목록 조회
        GameSvcCtntPstdLstInqApi(currentGameSvcCd, currentCtntCtgrCd, currentPage, "", null).then((resp)=> {
            switch(resp.apiHdr.code){
                case "GAME0000":
                    setCtntCtxtState(resp.apiBody.ctntLst);
                    setCtntKindCdState(resp.apiBody.ctntLst)
                    setPageState(resp.apiBody.nowPageNo)
                    setOnePageSizeState(resp.apiBody.onePageSize)
                    setTotPstdCntState(resp.apiBody.totCnt)
                    setTopFixCtntState(resp.apiBody.ctntTopFixLst);
                    break;
                default:
                    ApiError(langData,resp.apiHdr.code);
                    break;
            }
        })
        
        // // 상단 고정 게시글 조회
        // GameSvcCtntLstTopFixInqApi(currentGameSvcCd, currentCtntCtgrCd).then((resp)=> {
        //     switch(resp.apiHdr.code){
        //         case "MEMB0000":
        //             setTopFixCtntState(resp.apiBody.ctntTopFixLst);
        //             break;
        //         default:
        //             ApiError(langData,resp.apiHdr.code);
        //             break;
        //     }
        // })
    }, [location.search, MgpStore.getState().LangSetState.Lang]); // location.search를 의존성에 추가
    const [ctntCtgrCdCd,setctntCtgrCdCd] = useState(ctntKindCd);
    
    // 현재 URL 파라미터를 한 번만 계산하고 저장
    const currentParams = getCurrentParams();
    
    // 현재 URL에서 대메뉴 찾기 (메뉴 데이터용)
    const currentMainMenu = gameMainPageData?.menu?.find((menu: any) => {
        if (currentParams.currentCtntCtgrCd) {
            return menu.subMenuLst?.some((sub: any) => {
                const urlParams = new URLSearchParams(sub.url?.split('?')[1] || '');
                const subCtntKindCd = urlParams.get('ctntKindCd');
                return subCtntKindCd === currentParams.currentCtntCtgrCd;
            });
        }
        const currentPath = location.pathname.toLowerCase();
        const menuCd = menu.menuCd?.toLowerCase() || '';
        return currentPath.includes(menuCd) || 
               menu.subMenuLst?.some((sub: any) => {
                   const subMenuCd = sub.menuCd?.toLowerCase() || '';
                   return currentPath.includes(subMenuCd);
               });
    });
    
    // 모바일 카테고리 메뉴 열림 시 body 스크롤 방지
    useEffect(() => {
        if (isMobileCategoryOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobileCategoryOpen]);

    // 동적 메뉴 데이터 - 현재 대메뉴의 subMenuLst 추출
    const ctntMenuData = currentMainMenu?.subMenuLst?.map((subMenu: any) => {
        // URL에서 ctntKindCd 파라미터 추출
        const urlParams = new URLSearchParams(subMenu.url?.split('?')[1] || '');
        const ctntKindCd = urlParams.get('ctntKindCd') || subMenu.menuCd;
        
        return {
            Link: subMenu.url || '#',
            Txt: subMenu.menuNm,
            Display: subMenu.useYn,
            Code: ctntKindCd, // URL에서 추출한 ctntKindCd 사용
            BlankYn: subMenu.blankYn
        };
    }) || [];
    
    // 표시되는 메뉴만 필터링
    const visibleMenus = ctntMenuData.filter((menu: any) => menu.Display === "Y");
    
    
    
    return(
        <>
            {/* <Helmet>
                <title></title>
            </Helmet> */}
            <div className="BgW">
            <GamePageBanner gameMainPageData={gameMainPageData} langData={langData} />
            <div className="container1580 mt30">
                <button
                    className="mobileCategoryBtn"
                    onClick={() => setIsMobileCategoryOpen(!isMobileCategoryOpen)}
                >
                    <span>{visibleMenus.find((m:any)=>m.Code===currentParams.currentCtntCtgrCd)?.Txt || '카테고리'}</span>
                    <span className={`category-arrow ${isMobileCategoryOpen ? 'up' : 'down'}`}></span>
                </button>
                <h1 className="ctntCtgrTitlTxt">
                    <a href="/GamePage/Ctnt/CtntLst?gameSvcCd=BBO&ctntKindCd=PNOT" className="ctntCtgrTitlTxtLink">
                        NEWS
                    </a>
                </h1>
                <div className="ctntLstWrap ctntPstdLstWrap faqLstContentsWrap">
                    <div className="faqLst">

                        {isMobileCategoryOpen && (
                            <div className="mobileMenuOverlay" onClick={() => setIsMobileCategoryOpen(false)} />
                        )}

                        <CtntCategoryMenu
                            menus={visibleMenus}
                            activeCode={currentParams.currentCtntCtgrCd || ''}
                            className={`faqCtgrLstWrap ${isMobileCategoryOpen ? 'mobileOpen' : ''}`}
                            onSelect={(code: string) => {
                                setIsMobileCategoryOpen(false);
                                const menu = visibleMenus.find((m: any) => m.Code === code);
                                if (menu) navigate(menu.Link);
                            }}
                        />

                        <div className="faqCtxtLstWrap">
                            <div className="trmsContainer ctntCtgr">
                                <h1 className="ctntCtgrTitl">
                                    {currentParams.currentCtntCtgrCd == "PNOT" && langData?.GLB_PNOT_LST_TITL_00}
                                    {currentParams.currentCtntCtgrCd == "UPDT" && langData?.GLB_UPDT_LST_TITL_00}
                                    {currentParams.currentCtntCtgrCd == "EVNT" && langData?.GLB_EVNT_LST_TITL_00}
                                    {currentParams.currentCtntCtgrCd == "DVNT" && langData?.GAME_SVC_DVNT_PAGE_TITL_00}
                                </h1>
                            </div>

                            <div className="ctntLstContentsWrap">
                                {(topFixCtntState && topFixCtntState.length > 0) || (ctntCtxtState && ctntCtxtState.length > 0) ? 
                                    <>
                                    <ul className="ctntLstContentUl">
                                        {/* 상단 고정 게시글 */}
                                        {topFixCtntState && topFixCtntState.map((key:any) => (
                                            <li className="topFixCtnt" key={key.ctntSno}>
                                                <Link 
                                                    to={`/GamePage/Ctnt/CtntCtxt?gameSvcCd=${key.gameSvcCd}&ctntKindCd=${currentParams.currentCtntCtgrCd}&ctntSno=${key.ctntSno}&lang=${MgpStore.getState().LangSetState.Lang}`}
                                                    state={{ 
                                                        returnUrl: `${location.pathname}${location.search}`,
                                                        listPage: currentParams.currentPage,
                                                        listCategory: currentParams.currentCtntCtgrCd
                                                    }}
                                                >
                                                    <p className="ctntTitlTxt">
                                                        <span className="">&#x1F4CC;</span>
                                                        {key.ctntTitl}
                                                    </p>
                                                    <div className="ctntMetaInfo">
                                                        <p className="vwrCnt"><i className="eye"></i>{key.vwrCnt}</p>
                                                        <p className="ctntDate">{key.aplyStrtDtime}</p>
                                                    </div>
                                                </Link>
                                            </li>
                                        ))}
                                        {/* 일반 게시글 */}
                                        {ctntCtxtState&&ctntCtxtState.map((key:any) => (
                                            <li key={key.ctntSno}>
                                                <Link 
                                                    to={`/GamePage/Ctnt/CtntCtxt?gameSvcCd=${key.gameSvcCd}&ctntKindCd=${currentParams.currentCtntCtgrCd}&ctntSno=${key.ctntSno}&lang=${MgpStore.getState().LangSetState.Lang}`}
                                                    state={{ 
                                                        returnUrl: `${location.pathname}${location.search}`,
                                                        listPage: currentParams.currentPage,
                                                        listCategory: currentParams.currentCtntCtgrCd
                                                    }}
                                                >
                                                    <p className="ctntTitlTxt">{key.ctntTitl}</p>
                                                    <div className="ctntMetaInfo">
                                                        <p className="vwrCnt"><i className="eye"></i>{key.vwrCnt}</p>
                                                        <p className="ctntDate">{key.aplyStrtDtime}</p>
                                                    </div>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="ctntPageWrap">
                                        <Pagination
                                            activePage={currentParams.currentPage}
                                            itemsCountPerPage={onePageSizeState}
                                            totalItemsCount={totPstdCntState}
                                            pageRangeDisplayed={5}
                                            firstPageText={""}
                                            linkClassFirst={"pagenationBtn pagenationFirstBtn"}
                                            prevPageText={""}
                                            linkClassPrev={"pagenationBtn pagenationPrevBtn"}
                                            nextPageText={""}
                                            linkClassNext={"pagenationBtn pagenationNextBtn"}
                                            lastPageText={""}
                                            linkClassLast={"pagenationBtn pagenationLastBtn"}
                                            onChange={handlePageChange}
                                        />
                                    </div>
                                    </>:
                                    <><p className="noDataLi tCenter mt25">{langData&&langData.GLB_NO_DATA_LBL_00}</p></>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}
export default GameCtntPstdLstUi;